// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileDelete_wrapper__tCvGT","greeting":"ProfileDelete_greeting__mOuRd","title":"ProfileDelete_title__7uKBQ","text":"ProfileDelete_text__9qdXv"};